"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[50343],{

/***/ 50838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ ShopColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const ShopColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M12.9311 9.2069C12.8488 9.2069 12.7699 9.1742 12.7117 9.116C12.6535 9.0578 12.6208 8.97886 12.6208 8.89655V5.7931C12.6208 5.21694 12.3919 4.66438 11.9845 4.25698C11.5771 3.84957 11.0245 3.62069 10.4484 3.62069C9.87222 3.62069 9.31966 3.84957 8.91225 4.25698C8.50484 4.66438 8.27596 5.21694 8.27596 5.7931V8.89655C8.27596 8.97886 8.24327 9.0578 8.18507 9.116C8.12686 9.1742 8.04793 9.2069 7.96562 9.2069C7.88331 9.2069 7.80437 9.1742 7.74617 9.116C7.68797 9.0578 7.65527 8.97886 7.65527 8.89655V5.7931C7.65527 5.05233 7.94955 4.34189 8.47335 3.81808C8.99716 3.29427 9.7076 3 10.4484 3C11.1892 3 11.8996 3.29427 12.4234 3.81808C12.9472 4.34189 13.2415 5.05233 13.2415 5.7931V8.89655C13.2415 8.97886 13.2088 9.0578 13.1506 9.116C13.0924 9.1742 13.0134 9.2069 12.9311 9.2069Z",
          fill: "#DADCDE"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M13.5517 20.0689H3L3.62069 7.65515H12.931L13.5517 20.0689Z",
          fill: "#EB423F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M16.0346 20.0689H13.5518L12.9312 7.65515H15.4139L16.0346 20.0689Z",
          fill: "#D13330"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.8116 18.5168C14.8054 18.5172 14.7992 18.5172 14.793 18.5172C14.7138 18.5172 14.6377 18.4869 14.5802 18.4326C14.5227 18.3783 14.488 18.3041 14.4834 18.2251L13.8627 7.67338C13.8623 7.66718 13.8623 7.66136 13.8623 7.65515H14.4838L15.1033 18.1886C15.1081 18.2708 15.0801 18.3516 15.0254 18.4131C14.9707 18.4747 14.8938 18.512 14.8116 18.5168Z",
          fill: "#A82A27"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M20.9999 20.069H18.5172L18.4784 19.5674V19.567L17.8965 12H20.3792L20.9514 19.4363V19.4366L20.9999 20.069Z",
          fill: "#EBA72E"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M19.7897 18.5157C19.7793 18.5168 19.7688 18.5173 19.7583 18.5173C19.6814 18.5172 19.6073 18.4885 19.5503 18.4369C19.4934 18.3853 19.4576 18.3144 19.4499 18.2379L19.4386 18.127L18.8292 12.031C18.8281 12.0207 18.8276 12.0104 18.8276 12H19.4499L20.0597 18.0987L20.0675 18.1759C20.0715 18.2164 20.0676 18.2574 20.0558 18.2964C20.0441 18.3354 20.0248 18.3718 19.999 18.4033C19.9732 18.4349 19.9414 18.461 19.9055 18.4803C19.8696 18.4996 19.8303 18.5116 19.7897 18.5157Z",
          fill: "#E09F2C"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M21.0001 20.069H20.6269L19.7587 18.7663L18.8905 20.069H18.5173L18.4785 19.5674V19.567L19.4386 18.127L19.5003 18.0347C19.5287 17.9922 19.5671 17.9574 19.6122 17.9333C19.6573 17.9092 19.7076 17.8966 19.7587 17.8966C19.8098 17.8966 19.8601 17.9092 19.9052 17.9333C19.9502 17.9574 19.9887 17.9922 20.0171 18.0347L20.0597 18.0987L20.9516 19.4363V19.4367L21.0001 20.069Z",
          fill: "#E09F2C"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M18.5172 20.069H10.4482L11.0689 12H17.8965L18.5172 20.069Z",
          fill: "#F7B030"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M14.793 17.8966H14.1723C13.7609 17.8961 13.3665 17.7325 13.0756 17.4416C12.7847 17.1507 12.6211 16.7563 12.6206 16.3449V13.8621C12.6206 13.7798 12.6533 13.7009 12.7115 13.6427C12.7697 13.5845 12.8486 13.5518 12.931 13.5518C13.0133 13.5518 13.0922 13.5845 13.1504 13.6427C13.2086 13.7009 13.2413 13.7798 13.2413 13.8621V16.3449C13.2416 16.5917 13.3398 16.8284 13.5143 17.0029C13.6888 17.1774 13.9255 17.2756 14.1723 17.2759H14.793C15.0399 17.2756 15.2765 17.1774 15.4511 17.0029C15.6256 16.8284 15.7238 16.5917 15.7241 16.3449V13.8621C15.7241 13.7798 15.7568 13.7009 15.815 13.6427C15.8732 13.5845 15.9521 13.5518 16.0344 13.5518C16.1167 13.5518 16.1956 13.5845 16.2538 13.6427C16.312 13.7009 16.3447 13.7798 16.3447 13.8621V16.3449C16.3443 16.7563 16.1806 17.1507 15.8897 17.4416C15.5988 17.7325 15.2044 17.8961 14.793 17.8966Z",
          fill: "#E9EEF2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.79297 8.89661H6.41366V10.7587H5.79297V8.89661Z",
          fill: "#DADCDE"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M6.10331 9.2069C6.02101 9.2069 5.94207 9.1742 5.88387 9.116C5.82567 9.0578 5.79297 8.97886 5.79297 8.89655V5.7931C5.79297 5.05233 6.08724 4.34189 6.61105 3.81808C7.13486 3.29427 7.84529 3 8.58607 3C9.32685 3 10.0373 3.29427 10.5611 3.81808C11.0849 4.34189 11.3792 5.05233 11.3792 5.7931V8.89655C11.3792 8.97886 11.3465 9.0578 11.2883 9.116C11.2301 9.1742 11.1511 9.2069 11.0688 9.2069C10.9865 9.2069 10.9076 9.1742 10.8494 9.116C10.7912 9.0578 10.7585 8.97886 10.7585 8.89655V5.7931C10.7585 5.21694 10.5296 4.66438 10.1222 4.25698C9.71479 3.84957 9.16223 3.62069 8.58607 3.62069C8.00991 3.62069 7.45735 3.84957 7.04994 4.25698C6.64254 4.66438 6.41366 5.21694 6.41366 5.7931V8.89655C6.41366 8.97886 6.38096 9.0578 6.32276 9.116C6.26456 9.1742 6.18562 9.2069 6.10331 9.2069Z",
          fill: "#E9EEF2"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M7.03443 13.2414H5.17236V10.7586L6.1034 10.1379L7.03443 10.7586V13.2414Z",
          fill: "#F7B030"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 460241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ UnionOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const UnionOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 65 64", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.67391 32C4.67391 16.6356 17.1356 4.17391 32.5 4.17391C47.8644 4.17391 60.3261 16.6356 60.3261 32C60.3261 47.3644 47.8644 59.8261 32.5 59.8261C17.1356 59.8261 4.67391 47.3644 4.67391 32ZM32.5 0C14.8304 0 0.5 14.3304 0.5 32C0.5 49.6696 14.8304 64 32.5 64C50.1696 64 64.5 49.6696 64.5 32C64.5 14.3304 50.1696 0 32.5 0ZM29.9897 31.987L18.3869 20.3842C18.0652 20.0511 17.8873 19.605 17.8913 19.142C17.8954 18.679 18.0811 18.2361 18.4085 17.9087C18.7359 17.5812 19.1788 17.3955 19.6418 17.3915C20.1048 17.3875 20.5509 17.5655 20.8839 17.8871L20.8926 17.8955L32.4868 29.4899L44.0896 17.8871C44.4227 17.5654 44.8688 17.3875 45.3318 17.3915C45.7948 17.3955 46.2377 17.5812 46.5652 17.9087C46.8926 18.2361 47.0783 18.679 47.0823 19.142C47.0863 19.605 46.9083 20.0511 46.5867 20.3841L46.5783 20.3928L34.9839 31.987L46.5744 43.5775C46.7408 43.7394 46.8736 43.9326 46.9653 44.146C47.0579 44.3614 47.1066 44.5931 47.1086 44.8276C47.1106 45.0621 47.066 45.2946 46.9772 45.5116C46.8884 45.7286 46.7573 45.9258 46.5915 46.0916C46.4256 46.2574 46.2285 46.3885 46.0115 46.4773C45.7944 46.5661 45.5619 46.6108 45.3274 46.6088C45.093 46.6067 44.8613 46.558 44.6458 46.4655C44.4324 46.3738 44.2393 46.241 44.0773 46.0746L32.4868 34.4841L20.884 46.0869C20.551 46.4086 20.1048 46.5865 19.6418 46.5825C19.1788 46.5784 18.7359 46.3927 18.4085 46.0653C18.0811 45.7379 17.8954 45.295 17.8913 44.832C17.8873 44.369 18.0653 43.9229 18.387 43.5899L18.3954 43.5812L29.9897 31.987Z",
          fill: "#DA4343"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 875761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ComboProductPrice; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(591007);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);




const ComboProductPrice = (param)=>{
    let { price , promotion , textColor ,  } = param;
    const { numberDisplayFormat , applyNewLogicToCalculateComboPrice  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const renderPrice = (price)=>{
        var ref, ref1;
        const latestPrice = applyNewLogicToCalculateComboPrice || !((ref = promotion.condition) === null || ref === void 0 ? void 0 : (ref1 = ref.exclusions) === null || ref1 === void 0 ? void 0 : ref1.length) ? price.latestPrice : price.supplierRetailPrice;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_3__/* .ProductPrice */ .j, {
            latestPrice: latestPrice,
            supplierRetailPrice: price.supplierRetailPrice > latestPrice ? price.supplierRetailPrice : undefined,
            textColor: textColor,
            numberDisplayFormat: numberDisplayFormat
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: renderPrice(price)
    });
};


/***/ }),

/***/ 50343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ ProductSelectionModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(386877);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(411213);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(891256);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(309110);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(349416);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(651337);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(460241);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50838);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(971219);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(662295);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(534090);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var _PromotionBenefitInfo__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(987540);
/* harmony import */ var _ComboProductPrice__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(875761);
/* harmony import */ var modules_cart_utils__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(739069);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(428247);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(54230);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border-radius: 8px;\n  background-color: #f8f8fc;\n  padding: 16px;\n  margin-bottom: 12px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  width: 208px;\n  background-color: #ffffff;\n  cursor: pointer;\n  border-radius: 8px;\n  border: 1px solid #e4e5f0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 16px;\n  border-radius: 999px;\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 12px;\n  color: white;\n  padding: 2px 5px;\n  top: 8px;\n  left: 8px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  height: 72px;\n  width: 72px;\n  background-color: rgba(27, 29, 41, 0.5);\n  z-index: 1;\n  top: 0;\n  left: 0;\n  border-radius: 4px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}












const ProductSelectionModal = (param)=>{
    let { selectingProduct , visible , closeModal , activeCombo , setActiveCombo , productCombos , comboGroup , setComboGroup , handleConfirm , /** show/hide button "add combo to cart" in modal's footer */ showAddComboToCartButton =true , /**
   * wether to show all combos available to current active combo or only combos that has the same totalProduct
   * showAllCombos = false --> filter & show only combo that has the same totalProduct
   * showAllCombos = true --> show all combos available to current active combo
   */ showAllCombos =false ,  } = param;
    const { onAddComboItems  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useCartV2 */ .T6)();
    // Index of condition in its combo.
    // If user do not select any condition, default is the first condition in combo immediately after main product (main product's index is 0)
    const { 0: conditionIndex , 1: setConditionIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selectingProduct ? selectingProduct.conditionKey - 1 : 1);
    const { 0: selectingComboProduct , 1: setSelectingComboProduct  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const { 0: selectingCombo , 1: setSelectingCombo  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(activeCombo);
    const { numberDisplayFormat , applyNewLogicToCalculateComboPrice =false  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const updateActiveAndGroupCombo = ()=>{
        if (comboGroup && selectingCombo && selectingComboProduct) {
            const selectedGroup = comboGroup[selectingCombo.totalProduct];
            setActiveCombo(selectingCombo);
            setComboGroup(_objectSpreadProps(_objectSpread({}, comboGroup), {
                [selectingCombo.totalProduct]: {
                    combos: selectedGroup.combos.map((cb)=>cb.key === selectingCombo.key ? selectingCombo : cb)
                }
            }));
        }
    };
    const selectComboProduct = (product, cb)=>{
        if (selectingCombo) {
            // build new active combo based on the new selected product
            const comboTemp = _objectSpreadProps(_objectSpread({}, cb), {
                // Check if the select combo product in still in side the previous combo
                conditions: selectingCombo.key === cb.key ? selectingCombo.conditions.map((condition, index)=>{
                    return {
                        key: condition.key,
                        requiredQuantity: condition.requiredQuantity,
                        product: index === conditionIndex ? product : condition.product
                    };
                }) : // reset other indexes in active combo to products[0]
                cb.conditions.map((condition, index)=>{
                    return {
                        key: condition.key,
                        requiredQuantity: condition.requiredQuantity,
                        product: index === conditionIndex ? product : condition.products[0]
                    };
                })
            });
            const newActiveCombo = _objectSpreadProps(_objectSpread({}, comboTemp), {
                discountByCombo: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getDiscountByCombo */ .qE)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalDiscount: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getTotalDiscount */ .bb)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalAmount: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getTotalAmount */ .aU)(comboTemp, applyNewLogicToCalculateComboPrice)
            });
            setSelectingCombo(newActiveCombo);
            setSelectingComboProduct({
                sku: product.sku,
                conditionKey: cb.conditions[conditionIndex].key
            });
        }
    };
    const addComboToCart = async ()=>{
        if (selectingCombo) {
            updateActiveAndGroupCombo();
            const mainPayload = {
                override: true,
                groups: [
                    {
                        quantity: 1,
                        promotionId: selectingCombo.promotion.id,
                        products: selectingCombo.conditions.map((el, index)=>{
                            var ref, ref1;
                            return {
                                sku: el.product.sku,
                                promotionId: !!((ref = el.product.bestPromotionIds) === null || ref === void 0 ? void 0 : ref.length) ? (ref1 = el.product.bestPromotionIds) === null || ref1 === void 0 ? void 0 : ref1[0] : null,
                                quantity: el.requiredQuantity,
                                isPrimary: index === 0
                            };
                        })
                    }, 
                ]
            };
            await onAddComboItems(mainPayload, false);
            closeModal(selectingCombo);
        }
    };
    // List of combos have same product quantity with active combo
    const similarCombos = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (selectingCombo && (productCombos === null || productCombos === void 0 ? void 0 : productCombos.length)) {
            return showAllCombos ? productCombos : productCombos.filter((item)=>item.totalProduct === selectingCombo.totalProduct);
        }
        return [];
    }, [
        selectingCombo,
        productCombos
    ]);
    // Trigger open this modal, if have no active combo -> set default active combo is the first combo in productCombos
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (visible && !activeCombo && (productCombos === null || productCombos === void 0 ? void 0 : productCombos.length)) {
            const comboTemp = _objectSpreadProps(_objectSpread({}, productCombos[0]), {
                conditions: productCombos[0].conditions.map((_param)=>{
                    var { products  } = _param, restCondition = _objectWithoutProperties(_param, [
                        "products"
                    ]);
                    return _objectSpreadProps(_objectSpread({}, restCondition), {
                        product: products[0]
                    });
                })
            });
            const defaultCombo = _objectSpreadProps(_objectSpread({}, comboTemp), {
                discountByCombo: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getDiscountByCombo */ .qE)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalDiscount: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getTotalDiscount */ .bb)(comboTemp, applyNewLogicToCalculateComboPrice),
                totalAmount: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getTotalAmount */ .aU)(comboTemp, applyNewLogicToCalculateComboPrice)
            });
            setActiveCombo(defaultCombo);
            setSelectingCombo(defaultCombo);
        }
    }, [
        activeCombo,
        visible
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!selectingComboProduct) {
            if (selectingProduct) {
                setSelectingComboProduct(selectingProduct);
            } else {
                if (activeCombo) {
                    var ref, ref1;
                    setSelectingComboProduct({
                        sku: (ref = activeCombo.conditions[1]) === null || ref === void 0 ? void 0 : ref.product.sku,
                        conditionKey: (ref1 = activeCombo.conditions[1]) === null || ref1 === void 0 ? void 0 : ref1.key
                    });
                }
            }
        }
    }, [
        activeCombo,
        selectingProduct
    ]);
    const ComboProductImage = (param)=>{
        let { condition , index , selectingCombo  } = param;
        // Only show tooltip when length of conditions in combo > 2
        // If selecting product is the last item -> show tooltip for previous item, else show tooltip for next item
        const { 0: showTooltip , 1: setShowTooltip  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(selectingCombo.conditions.length > 2 && (conditionIndex === selectingCombo.conditions.length - 1 ? index === conditionIndex - 1 : index === conditionIndex + 1));
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .Tooltip */ .u, {
            title: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                onClick: ()=>setShowTooltip(false),
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UnionOutlined */ .o, {
                        size: 18,
                        style: {
                            position: "absolute",
                            top: -6,
                            right: -6,
                            backgroundColor: "#434657",
                            borderRadius: "100px"
                        },
                        color: "#fff"
                    }),
                    (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Chọn sản phẩm c\xf2n lại trong combo")
                ]
            }),
            show: showTooltip,
            triggerHover: false,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ImageWrapper, _objectSpreadProps(_objectSpread({
                highlight: index === conditionIndex
            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                isTrackContent: true,
                contentName: "changeProductInCombo",
                regionName: "detailProductComboList",
                payload: JSON.stringify({
                    skuComboIndex: index + 1
                })
            })), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w, {
                        src: condition.product.imageUrl,
                        borderRadius: 4,
                        border: true,
                        contain: true,
                        onClick: index !== 0 ? ()=>{
                            setConditionIndex(index);
                            setSelectingComboProduct({
                                sku: condition.product.sku,
                                conditionKey: condition.key
                            });
                            setShowTooltip(false);
                        } : undefined
                    }, index),
                    index === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledNotSelectImageBg, {})
                ]
            }))
        }, index);
    };
    return selectingCombo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Modal */ .u, _objectSpreadProps(_objectSpread({
        visible: visible,
        width: "75%",
        onClose: closeModal,
        footer: false
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        contentName: "popupChangeProductCombo",
        regionName: "detailProductComboList"
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_11__/* .ModalHeader */ .x, {
                padding: "s0",
                marginBottom: "s24",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                    direction: "column",
                    gap: "s4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Title */ .Dx, {
                            level: 1,
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Chọn sản phẩm trong combo")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                            level: 1,
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("C\xe1c combo kh\xe1c nhau c\xf3 thể c\xf3 ưu đ\xe3i kh\xe1c nhau")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__/* .ModalBody */ .f, {
                maxHeight: 500,
                style: {
                    overflowY: "scroll"
                },
                padding: "s0",
                children: similarCombos.map((cb, index)=>{
                    var ref, ref1;
                    // not render combo if condition at conditionIndex not have any products
                    if (!((ref = cb.conditions[conditionIndex]) === null || ref === void 0 ? void 0 : ref.products.length)) {
                        return;
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledWrapperComboItem, _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                        isTrackContent: true,
                        contentName: "blockComboPromotion".concat(index + 1),
                        regionName: "detailProductComboList",
                        payload: JSON.stringify({
                            comboIndex: index + 1
                        })
                    })), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                                marginBottom: "s16",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_15__/* .ShopColored */ .I, {
                                        size: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .SubTitle */ .DK, {
                                        level: 3,
                                        marginLeft: "s4",
                                        children: [
                                            "Combo ",
                                            index + 1
                                        ]
                                    })
                                ]
                            }),
                            cb.promotion.benefit && (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .countAndGetBenefitDescription */ .sE)(cb.promotion.benefit, numberDisplayFormat).numberOfBenefit >= 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                style: {
                                    marginBottom: "16px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Caption */ .YS, {
                                        level: 2,
                                        color: "textSecondary",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Bạn nhận được").toUpperCase()
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PromotionBenefitInfo__WEBPACK_IMPORTED_MODULE_16__/* .PromotionBenefitInfo */ .j, {
                                        promotionBenefit: cb.promotion.benefit,
                                        backgroundColor: "white"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_17__/* .Glide */ .A, {
                                perView: window.innerWidth * 0.7 / 220,
                                children: (ref1 = cb.conditions[conditionIndex]) === null || ref1 === void 0 ? void 0 : ref1.products.map((product, i)=>{
                                    const productLink = (0,modules_cart_utils__WEBPACK_IMPORTED_MODULE_18__/* .getConditionProductLinkObj */ .lL)(product);
                                    const isSelectedProduct = cb.key === (selectingCombo === null || selectingCombo === void 0 ? void 0 : selectingCombo.key) && cb.conditions[conditionIndex].key === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.conditionKey) && product.sku === (selectingComboProduct === null || selectingComboProduct === void 0 ? void 0 : selectingComboProduct.sku);
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ProductItemWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__/* .CustomLink */ .x, _objectSpreadProps(_objectSpread({}, productLink), {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .LazyImage */ .w, {
                                                    src: product.imageUrl,
                                                    hover: "zoom",
                                                    contain: true,
                                                    alt: product.name,
                                                    aspectRatio: 1,
                                                    width: 166,
                                                    height: 166
                                                })
                                            })),
                                            cb.conditions[conditionIndex].requiredQuantity > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(QuantityTag, {
                                                backgroundColor: "primary500",
                                                children: [
                                                    cb.conditions[conditionIndex].requiredQuantity,
                                                    "x"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_19__/* .CustomLink */ .x, _objectSpreadProps(_objectSpread({}, productLink), {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                                    hoverColor: "primary500",
                                                    marginTop: "s8",
                                                    level: 1,
                                                    line: 3,
                                                    color: "#434657",
                                                    height: 60,
                                                    children: product.name
                                                })
                                            })),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                style: {
                                                    width: "100%",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ComboProductPrice__WEBPACK_IMPORTED_MODULE_20__/* .ComboProductPrice */ .$, {
                                                    price: product.price,
                                                    promotion: cb.promotion
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpreadProps(_objectSpread({
                                                style: {
                                                    width: "100%",
                                                    alignItems: "center"
                                                }
                                            }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                                                isTrackContent: true,
                                                contentName: "selectProduct",
                                                regionName: "detailProductComboList",
                                                payload: JSON.stringify({
                                                    comboIndex: index + 1,
                                                    skuIndex: i + 1,
                                                    sku: product.sku
                                                })
                                            })), {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Button */ .z, {
                                                    variant: "secondary",
                                                    width: "100%",
                                                    marginTop: "s8",
                                                    onClick: ()=>selectComboProduct(product, cb),
                                                    disabled: isSelectedProduct,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .SubTitle */ .DK, {
                                                        level: 4,
                                                        weight: "medium",
                                                        children: isSelectedProduct ? (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Đ\xe3 chọn") : (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Chọn")
                                                    })
                                                })
                                            }))
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    }), index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_22__/* .ModalFooter */ .m, {
                borderTop: "1px solid #E4E5F0",
                padding: "s0",
                style: {
                    display: "grid",
                    gridTemplateColumns: "100%"
                },
                children: [
                    (selectingCombo === null || selectingCombo === void 0 ? void 0 : selectingCombo.promotion.benefit) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                        gap: "s4",
                        justify: "start",
                        align: "center",
                        marginTop: "s8",
                        marginBottom: "s8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_23__/* .GiftColored */ .x, {
                                size: 20
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                level: 1,
                                line: 2,
                                children: [
                                    "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Bạn nhận được"), ": "),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        style: {
                                            fontWeight: "bold"
                                        },
                                        children: (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .countAndGetBenefitDescription */ .sE)(selectingCombo.promotion.benefit, numberDisplayFormat).benefitDescription
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                        justify: "space-between",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                                gap: "s12",
                                children: selectingCombo.conditions.map((c, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ComboProductImage, {
                                        condition: c,
                                        index: index,
                                        selectingCombo: selectingCombo
                                    }, index))
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_24__/* .Shape */ .b, {
                                        marginRight: "s32",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                                        level: 1,
                                                        marginRight: "s8",
                                                        children: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Tiết kiệm"), ":")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                                        level: 1,
                                                        children: (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__/* .formatCurrency */ .xG)(selectingCombo.totalDiscount, numberDisplayFormat)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Flex */ .k, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Body */ .uT, {
                                                            level: 2,
                                                            marginRight: "s4",
                                                            children: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Tổng tiền"), ":")
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Title */ .Dx, {
                                                            level: 2,
                                                            color: "primary500",
                                                            children: (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_25__/* .formatCurrency */ .xG)(selectingCombo.totalAmount, numberDisplayFormat)
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    showAddComboToCartButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                                        isTrackContent: true,
                                        contentName: "btnAddToCart",
                                        regionName: "detailProductComboList",
                                        payload: JSON.stringify({
                                            promotionType: "combo",
                                            comboTab: "Combo ".concat(selectingCombo.totalProduct, " sản phẩm"),
                                            comboPromotion: selectingCombo.promotion.id,
                                            comboIndex: selectingCombo.key,
                                            skus: selectingCombo.conditions.map((c)=>c.product.sku)
                                        })
                                    })), {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Button */ .z, {
                                            variant: "secondary",
                                            marginRight: "s16",
                                            onClick: addComboToCart,
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("Th\xeam v\xe0o giỏ")
                                        })
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
                                        isTrackContent: true,
                                        contentName: "btnConfirmCombo",
                                        regionName: "detailProductComboList",
                                        payload: JSON.stringify({
                                            comboPromotion: selectingCombo.promotion.id
                                        })
                                    })), {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_21__/* .Button */ .z, {
                                            variant: "primary",
                                            onClick: ()=>{
                                                updateActiveAndGroupCombo();
                                                handleConfirm === null || handleConfirm === void 0 ? void 0 : handleConfirm(selectingCombo);
                                                closeModal(selectingCombo);
                                                setSelectingComboProduct(undefined);
                                                setSelectingCombo(undefined);
                                            },
                                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_7__.t)("X\xe1c nhận")
                                        })
                                    }))
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    })) : null;
};
const StyledWrapperComboItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__["default"].div(_templateObject());
const ProductItemWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__["default"].div(_templateObject1());
const QuantityTag = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_24__/* .Shape */ .b)(_templateObject2());
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__["default"].div((param)=>{
    let { theme , highlight  } = param;
    return "\n    border: ".concat(highlight ? "1.5px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.brand.primary) : "none", ";\n    border-radius: 4px;\n    height: 72px;\n    width: 72px;\n    position: relative;\n");
});
const StyledNotSelectImageBg = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_26__["default"].div(_templateObject3());


/***/ }),

/***/ 987540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PromotionBenefitInfo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(634655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(290184);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(526397);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54230);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(684443);






const PromotionBenefitInfo = (param)=>{
    let { promotionBenefit , gifts , backgroundColor ,  } = param;
    const { numberDisplayFormat  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useTenantConfig */ .Wx)();
    const getBenefits = (benefit)=>{
        let count = 0;
        const benefits = [];
        const { discount , voucher , gifts  } = benefit;
        const discountValue = (discount === null || discount === void 0 ? void 0 : discount.flat) || (discount === null || discount === void 0 ? void 0 : discount.percent) || 0;
        if (discount && discountValue > 0) {
            count++;
            benefits.push({
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBgPromotion, {
                    bgColor: "#E7FBED",
                    size: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .CashColored */ .B, {
                        size: 30
                    })
                }),
                name: "".concat((0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Giảm ngay"), " ").concat((discount === null || discount === void 0 ? void 0 : discount.flat) ? (0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrency */ .xG)(discountValue, numberDisplayFormat) : "".concat(discountValue, "%") + (discount.maxAmount ? " ".concat((0,i18n__WEBPACK_IMPORTED_MODULE_3__.t)("Giảm tối đa"), " ").concat((0,_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_4__/* .formatCurrency */ .xG)(discount.maxAmount, numberDisplayFormat)) : ""))
            });
        }
        if (voucher) {
            count++;
            benefits.push({
                icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledBgPromotion, {
                    bgColor: "#FFF2F0",
                    size: "40px",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .VoucherColored */ .C, {
                        size: 30
                    })
                }),
                name: voucher.name,
                quantity: voucher.quantity
            });
        }
        if (gifts && !!gifts.length) {
            count++;
            gifts.forEach((gift)=>{
                benefits.push({
                    image: gift.imageUrl,
                    name: gift.name,
                    quantity: gift.quantity
                });
            });
        }
        return {
            numberOfBenefit: count,
            benefits
        };
    };
    const benefits = gifts ? gifts : promotionBenefit ? getBenefits(promotionBenefit).benefits : [];
    return benefits.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DetailInfoItem, {
        backgroundColor: backgroundColor,
        children: benefits.map((param, index)=>/*#__PURE__*/ {
            let { name , image , quantity , icon  } = param;
            return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                width: "100%",
                align: "center",
                marginBottom: "s4",
                children: [
                    icon ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: icon
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, {
                        src: image || "",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_8__/* .Body */ .uT, {
                        level: 1,
                        line: 2,
                        marginLeft: "s8",
                        children: [
                            quantity && quantity > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                style: {
                                    color: "#2b2b2b"
                                },
                                children: "".concat(quantity, " x ")
                            }),
                            name
                        ]
                    })
                ]
            }, index);
        })
    }) : null;
};
const DetailInfoItem = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div((param)=>{
    let { backgroundColor ="#f8f8fc"  } = param;
    return "\n  border-radius: 8px;\n  background-color: ".concat(backgroundColor, ";\n  padding: 12px 16px;\n  margin-top: 12px;\n");
});
const StyledBgPromotion = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__["default"].div((param)=>{
    let { bgColor , size ="125px"  } = param;
    return "\n  width: ".concat(size, ";\n  height: ").concat(size, ";\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: ").concat(bgColor, ";\n  border-radius: 4px;\n");
});


/***/ })

}]);